import React, { Component } from "react";
import __ from "lodash";
import LoaderModal from "../../../../../modal/LoaderModal";
import { Row, Col, Alert } from "react-bootstrap";
import "./report.css";
import { CONFIG } from "../../../../../../config";
import accountManagement from "../../../../../../apis/accountManagement";
import { Pie } from "react-chartjs-2";
import TblKategoriKompetensi from "./TblKategoriKompetensi";
import TblKonversiSkor from "./TblKonversiSkor";
import HasilAsmMinimumProv from "./HasilAsmMinimumProv";
import TblAsmCabangDinas from "./TblAsmCabangDinas";
import GraphKomparasiSkorCabang from "./GraphKomparasiSkorCabang";
import TblAsmCabangKompetensi from "./TblAsmCabangKompetensi";
import TblAsmSekolahDinas from "./TblAsmSekolahDinas";
import GraphPie from "./GraphPie";
import GraphBarSvKarakter from "./GraphBarSvKarakter";
import TblSvKarakterSekolah from "./TblSvKarakterSekolah";
import GraphSosEkonomi from "./GraphSosEkonomi";
import TblSosEkonomi from "./TblSosEkonomi";
// import ChartDataLabels from "chartjs-plugin-datalabels";
import PrintIcon from "@material-ui/icons/Print";
import env from "react-dotenv";

// import response from './response.json';
// import res from './res.json';

class ReportAsmDinas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            alertShow: false,
            resMessage: "message",
            params: this.props.match.params,
            // namaProvinsi : res.data.provinsi,
            // namaDisdikSelected : res.data.cabdindik,
            // dataProvinsi: res.data.dataProvinsi,
            // dataDisdik: res.data.dataDisdik,
            // dataKabupaten: res.data.dataKab,
            // dataSekolah: res.data.dataKabSekolah,
            // nonAkademikProvinsi: res.data.nonAkaProvinsi,
            // nonAkademikKabupaten: res.data.nonAkaKab,
            // nonAkademikSekolah: res.data.nonAkaSekolah,
            // indekSosialProvinsi: res.data.indekSosialProv,
            // indekSosialKabupaten: res.data.indekSosialKab,
            namaProvinsi: "",
            namaDisdikSelected: "",
            dataProvinsi: [],
            dataDisdik: [],
            dataKabupaten: [],
            dataSekolah: [],
            nonAkademikProvinsi: { SK: [], SLB: [] },
            nonAkademikKabupaten: { SK: [], SLB: [] },
            nonAkademikSekolah: [],
            indekSosialProvinsi: [],
            indekSosialKabupaten: [],
        };
    }

    async componentDidMount() {
        if (!__.isUndefined(this.props.match.params)) {
            this.fetchReport();
        }
        // console.log(this.props.match.params)
    }

    fetchReport = async () => {
        this.setState({ isFetching: true });
        const response = await accountManagement.get(CONFIG.GET_REPORT_ASM_DINAS, { params: this.state.params }).catch(function (error) {
            this.setState({ alertShow: true, resMessage: "Error.. Please refresh..." });
        });
        if (response) {
            if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    namaProvinsi: response.data.data.provinsi,
                    namaDisdikSelected: response.data.data.cabdindik,
                    dataProvinsi: response.data.data.dataProvinsi,
                    dataDisdik: response.data.data.dataDisdik,
                    dataKabupaten: response.data.data.dataKab,
                    dataSekolah: response.data.data.dataKabSekolah,
                    nonAkademikProvinsi: response.data.data.nonAkaProvinsi,
                    nonAkademikKabupaten: response.data.data.nonAkaKab,
                    nonAkademikSekolah: response.data.data.nonAkaSekolah,
                    indekSosialProvinsi: response.data.data.indekSosialProv,
                    indekSosialKabupaten: response.data.data.indekSosialKab,
                });
            } else {
                this.setState({ alertShow: true, resMessage: response.data.errorSchema.errorMessage });
            }
            this.setState({ isFetching: false });
        }
    };

    render() {
        return (
            <div className="container-fluid layout" style={{ paddingBottom: "50px" }}>
                <LoaderModal isFetching={this.state.isFetching} />
                {this.loadAlert()}

                <div className="header-box">
                    <Row>
                        <Col>
                            <div className="header-box-text">REPORT ASESMEN NASIONAL</div>
                            <div className="header-box-text-small">Dinas Pendidikan {this.state.namaProvinsi}</div>
                            <img src={process.env.REACT_APP_URL_SISWA_FE + "/static/images/eduprime_tulisan_hitam.png"} width="180px"></img>
                        </Col>
                    </Row>
                </div>

                {!this.state.isFetching && (
                    <div>
                        {/* ===================== AKADEMIK ======================== */}
                        <div className="content-div">
                            <Row>
                                <Col>
                                    <div className="judul">ASESMEN KOMPETENSI MINIMUM</div>
                                </Col>
                            </Row>
                            <br />

                            <Row>
                                <Col className="content-div-title">STATISTIK ASESMEN KOMPETENSI MINIMUM PROVINSI</Col>
                            </Row>
                            <br />

                            <Row>
                                {this.state.dataProvinsi.map((value, i) => (
                                    <Col key={i}>
                                        <div className="content-box">{this.pieChart(value)}</div>
                                    </Col>
                                ))}
                            </Row>
                            <br />

                            <Row>
                                <Col sm={5}>
                                    <div className="content-div-title">HASIL PENGKATEGORIAN LEVEL KOMPETENSI</div>
                                    {this.state.dataProvinsi.length > 0 && <TblKategoriKompetensi data={this.state.dataProvinsi} />}
                                </Col>
                                <Col sm={7}>
                                    <div className="content-div-title">KONVERSI SKOR</div>
                                    {this.state.dataProvinsi.length > 0 && <TblKonversiSkor data={this.state.dataProvinsi} />}
                                </Col>
                            </Row>
                            <br />

                            <div className="content-div">
                                <div className="content-div-title">CAPAIAN HASIL ASESMEN KOMPETENSI MINIMUM PROVINSI</div>
                                {this.state.dataDisdik.length > 0 && (
                                    <Row>
                                        <Col>
                                            <div className="content-box">
                                                <HasilAsmMinimumProv data={this.state.dataDisdik} mapel="LITERASI" />
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="content-box">
                                                <HasilAsmMinimumProv data={this.state.dataDisdik} mapel="NUMERASI" />
                                            </div>
                                        </Col>
                                    </Row>
                                )}
                                <br />

                                <Row>
                                    <Col>{this.state.dataDisdik.length > 0 && <TblAsmCabangDinas data={this.state.dataDisdik} />}</Col>
                                </Row>
                            </div>

                            <div className="content-div page-break">
                                <div className="content-div-title">STATISTIK ASESMEN KOMPETENSI MINIMUM CABANG {this.state.namaDisdikSelected}</div>
                                <Row>
                                    {this.state.dataKabupaten.map((data, i) => (
                                        <Col key={i}>
                                            <div className="content-box">{this.pieChart(data)}</div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="content-div">
                                <h5>HASIL PENGKATEGORIAN LEVEL KOMPETENSI</h5>
                                <Row>
                                    <Col sm={6}>{this.state.dataKabupaten.length > 0 && <TblKategoriKompetensi data={this.state.dataKabupaten} />}</Col>
                                </Row>
                            </div>

                            <div className="content-div">
                                <h5>KOMPARASI KONVERSI SKOR</h5>
                                <Row>
                                    {this.state.dataProvinsi.map((data, i) => (
                                        <Col key={i}>
                                            <GraphKomparasiSkorCabang dataProvinsi={data.kategories} dataDinas={this.state.dataKabupaten.find((f) => f.namaMataPelajaran === data.namaMataPelajaran)} />
                                        </Col>
                                    ))}
                                </Row>
                                <br />

                                <Row>
                                    <Col>{this.state.dataKabupaten.length > 0 && <TblAsmCabangKompetensi data={this.state.dataKabupaten} dataProvinsi={this.state.dataProvinsi} />}</Col>
                                </Row>
                            </div>

                            <div className="content-div page-break">
                                <div className="content-div-title">DETAIL HASIL ASESMEN KOMPETENSI MINIMUM {this.state.namaDisdikSelected}</div>
                                <Row>
                                    <Col>{this.state.dataSekolah.length > 0 && <TblAsmSekolahDinas data={this.state.dataSekolah} />}</Col>
                                </Row>
                            </div>
                        </div>

                        {/* ===================== SK ======================== */}
                        <div className="content-div page-break">
                            <Row>
                                <Col>
                                    <div className="judul">SURVEI KARAKTER</div>
                                </Col>
                            </Row>
                        </div>

                        <div className="content-div">
                            <div className="content-div-title">STATISTIK SURVEI KARAKTER PROVINSI</div>
                            <Row>
                                {this.state.nonAkademikProvinsi.SK.map((data, i) => (
                                    <Col key={i} sm={4}>
                                        <div className="content-box" style={{ marginBottom: "20px" }}>
                                            <GraphPie data={data} tipe={"SK"} />
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>

                        <div className="content-div">
                            <Row>
                                <Col style={{ marginLeft: "15%", marginRight: "15%" }}>
                                    {this.state.nonAkademikProvinsi.SK.length > 0 && (
                                        <table className="table-asm" width="100%" border="1">
                                            <thead>
                                                <tr>
                                                    <th className="text-center" rowSpan="2">
                                                        Aspek Profil Pelajar Pancasila
                                                    </th>
                                                    <th className="text-center" colSpan="2">
                                                        Unggul
                                                    </th>
                                                    <th className="text-center" colSpan="2">
                                                        Baik
                                                    </th>
                                                    <th className="text-center" colSpan="2">
                                                        Cukup
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th className="text-center">Jumsis</th>
                                                    <th className="text-center">%</th>
                                                    <th className="text-center">Jumsis</th>
                                                    <th className="text-center">%</th>
                                                    <th className="text-center">Jumsis</th>
                                                    <th className="text-center">%</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {this.state.nonAkademikProvinsi.SK.map((data, i) => (
                                                    <tr key={i}>
                                                        <td>{data.aspek}</td>
                                                        <td className="text-center">{data.sangatBaik}</td>
                                                        <td className="text-center">{data.pSangatBaik}</td>
                                                        <td className="text-center">{data.baik}</td>
                                                        <td className="text-center">{data.pBaik}</td>
                                                        <td className="text-center">{data.cukup}</td>
                                                        <td className="text-center">{data.pCukup}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </Col>
                            </Row>
                            <br />
                        </div>

                        <div className="content-div page-break">
                            <div className="content-div-title">STATISTIK SURVEI KARAKTER CABANG DINAS {this.state.namaDisdikSelected}</div>

                            <Row>
                                {this.state.nonAkademikKabupaten.SK.map((data, i) => (
                                    <Col key={i} sm={4}>
                                        <div className="content-box" style={{ marginBottom: "20px" }}>
                                            <GraphBarSvKarakter tipe={"SK"} data={data} dataProvinsi={this.state.nonAkademikProvinsi.SK.find((v) => v.aspek === data.aspek)} />
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                        <div className="content-div">
                            <Row>
                                <Col style={{ marginLeft: "15%", marginRight: "15%" }}>
                                    {this.state.nonAkademikKabupaten.SK.length > 0 && (
                                        <table className="table-asm" width="100%" border="1">
                                            <thead>
                                                <tr>
                                                    <th className="text-center" rowSpan="2">
                                                        Aspek Profil Pelajar Pancasila
                                                    </th>
                                                    <th className="text-center" colSpan="2">
                                                        Unggul
                                                    </th>
                                                    <th className="text-center" colSpan="2">
                                                        Baik
                                                    </th>
                                                    <th className="text-center" colSpan="2">
                                                        Cukup
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th className="text-center">Jumsis</th>
                                                    <th className="text-center">%</th>
                                                    <th className="text-center">Jumsis</th>
                                                    <th className="text-center">%</th>
                                                    <th className="text-center">Jumsis</th>
                                                    <th className="text-center">%</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {this.state.nonAkademikKabupaten.SK.map((data, i) => (
                                                    <tr key={i}>
                                                        <td>{data.aspek}</td>
                                                        <td className="text-center">{data.sangatBaik}</td>
                                                        <td className="text-center">{data.pSangatBaik}</td>
                                                        <td className="text-center">{data.baik}</td>
                                                        <td className="text-center">{data.pBaik}</td>
                                                        <td className="text-center">{data.cukup}</td>
                                                        <td className="text-center">{data.pCukup}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </Col>
                            </Row>
                            <br />
                        </div>

                        <div className="content-div page-break">
                            <div className="content-div-title">DETAIL HASIL SURVEI KARAKTER {this.state.namaDisdikSelected}</div>
                            {this.state.nonAkademikKabupaten.SK.length > 0 && (
                                <Row>
                                    {this.state.nonAkademikKabupaten.SK.map((data, i) => (
                                        <Col sm={6} key={i} style={{ marginBottom: "20px" }}>
                                            <TblSvKarakterSekolah aspek={data.aspek} tipe="SK" data={this.state.nonAkademikSekolah} />
                                        </Col>
                                    ))}
                                </Row>
                            )}
                        </div>

                        {/* ===================== SURVEI LINGKUNGAN BELAJAR ======================== */}
                        <div className="content-div page-break">
                            <Row>
                                <Col>
                                    <div className="judul">SURVEI LINGKUNGAN BELAJAR</div>
                                </Col>
                            </Row>
                        </div>

                        <div className="content-div">
                            <div className="content-div-title">STATISTIK SURVEI LINGKUNGAN BELAJAR PROVINSI</div>

                            <Row>
                                {this.state.nonAkademikProvinsi.SLB.map((data, i) => (
                                    <Col key={i} sm={4}>
                                        <div className="content-box" style={{ marginBottom: "20px" }}>
                                            <GraphPie data={data} />
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>

                        <div className="content-div">
                            <Row>
                                <Col style={{ marginLeft: "15%", marginRight: "15%" }}>
                                    {this.state.nonAkademikProvinsi.SLB.length > 0 && (
                                        <table className="table-asm" width="100%" border="1">
                                            <thead>
                                                <tr>
                                                    <th className="text-center" rowSpan="2">
                                                        Aspek Survei Lingkungan Belajar
                                                    </th>
                                                    <th className="text-center" colSpan="2">
                                                        Sangat Baik
                                                    </th>
                                                    <th className="text-center" colSpan="2">
                                                        Baik
                                                    </th>
                                                    <th className="text-center" colSpan="2">
                                                        Cukup
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th className="text-center">Jumsis</th>
                                                    <th className="text-center">%</th>
                                                    <th className="text-center">Jumsis</th>
                                                    <th className="text-center">%</th>
                                                    <th className="text-center">Jumsis</th>
                                                    <th className="text-center">%</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.nonAkademikProvinsi.SLB.map((data, i) => (
                                                    <tr key={i}>
                                                        <td>{data.aspek}</td>
                                                        <td className="text-center">{data.sangatBaik}</td>
                                                        <td className="text-center">{data.pSangatBaik}</td>
                                                        <td className="text-center">{data.baik}</td>
                                                        <td className="text-center">{data.pBaik}</td>
                                                        <td className="text-center">{data.cukup}</td>
                                                        <td className="text-center">{data.pCukup}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </Col>
                            </Row>
                            <br />
                        </div>

                        <div className="content-div page-break">
                            <div className="content-div-title">STATISTIK SURVEI LINGKUNGAN BELAJAR CABANG DINAS {this.state.namaDisdikSelected}</div>
                            {this.state.nonAkademikKabupaten.SLB.length > 0 && (
                                <Row>
                                    {this.state.nonAkademikKabupaten.SLB.map((data, i) => (
                                        <Col key={i} sm={4}>
                                            <div className="content-box" style={{ marginBottom: "20px" }}>
                                                <GraphBarSvKarakter data={data} dataProvinsi={this.state.nonAkademikProvinsi.SLB.find((v) => v.aspek === data.aspek)} />
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            )}
                        </div>
                        <div className="content-div">
                            <Row>
                                <Col style={{ marginLeft: "15%", marginRight: "15%" }}>
                                    {this.state.nonAkademikKabupaten.SLB.length > 0 && (
                                        <table className="table-asm" width="100%" border="1">
                                            <thead>
                                                <tr>
                                                    <th className="text-center" rowSpan="2">
                                                        Aspek Survei Lingkungan Belajar
                                                    </th>
                                                    <th className="text-center" colSpan="2">
                                                        Sangat Baik
                                                    </th>
                                                    <th className="text-center" colSpan="2">
                                                        Baik
                                                    </th>
                                                    <th className="text-center" colSpan="2">
                                                        Cukup
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th className="text-center">Jumsis</th>
                                                    <th className="text-center">%</th>
                                                    <th className="text-center">Jumsis</th>
                                                    <th className="text-center">%</th>
                                                    <th className="text-center">Jumsis</th>
                                                    <th className="text-center">%</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.nonAkademikKabupaten.SLB.map((data, i) => (
                                                    <tr key={i}>
                                                        <td>{data.aspek}</td>
                                                        <td className="text-center">{data.sangatBaik}</td>
                                                        <td className="text-center">{data.pSangatBaik}</td>
                                                        <td className="text-center">{data.baik}</td>
                                                        <td className="text-center">{data.pBaik}</td>
                                                        <td className="text-center">{data.cukup}</td>
                                                        <td className="text-center">{data.pCukup}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </Col>
                            </Row>
                            <br />
                        </div>

                        <div className="content-div page-break">
                            <div className="content-div-title">DETAIL SURVEI LINGKUNGAN BELAJAR {this.state.namaDisdikSelected}</div>
                            {this.state.nonAkademikKabupaten.SLB.length > 0 && (
                                <Row>
                                    {this.state.nonAkademikKabupaten.SLB.map((data, i) => (
                                        <Col sm={6} key={i} style={{ marginBottom: "20px" }}>
                                            <TblSvKarakterSekolah aspek={data.aspek} tipe="SLB" data={this.state.nonAkademikSekolah} />
                                        </Col>
                                    ))}
                                </Row>
                            )}
                        </div>

                        {/* ===================== SOSIAL EKONOMI ======================== */}
                        <div className="content-div page-break">
                            <Row>
                                <Col>
                                    <div className="judul">INDEKS SOSIAL-EKONOMI SISWA</div>
                                    <br />
                                    <p>Berdasarkan kuisioner Survei Lingkungan Belajar terkait Indeks Sosial Ekonomi, diperoleh data sebagai berikut:</p>
                                </Col>
                            </Row>
                        </div>

                        <div className="content-div">
                            <div className="content-div-title">PROVINSI</div>
                            <Row>
                                {this.state.indekSosialProvinsi.map((data, i) => (
                                    <Col key={i} sm={6} style={{ marginLeft: "auto", marginRight: "auto" }}>
                                        <div className="content-box" style={{ marginBottom: "20px" }}>
                                            <GraphSosEkonomi tipe={"PROV"} title={data.soal} data={data.kategori} />
                                        </div>
                                    </Col>
                                ))}
                            </Row>

                            <Row>
                                <Col>{this.state.indekSosialProvinsi.length > 0 && <TblSosEkonomi data={this.state.indekSosialProvinsi} />}</Col>
                            </Row>
                        </div>

                        <div className="content-div page-break">
                            <div className="content-div-title">CABANG DINAS {this.state.namaDisdikSelected}</div>
                            <Row>
                                {this.state.indekSosialKabupaten.map((data, i) => (
                                    <Col key={i} sm={6} style={{ marginLeft: "auto", marginRight: "auto" }}>
                                        <div className="content-box" style={{ marginBottom: "20px" }}>
                                            <GraphSosEkonomi tipe={"DINAS"} title={data.soal} data={data.kategori} />
                                        </div>
                                    </Col>
                                ))}
                            </Row>

                            <Row>
                                <Col>{this.state.indekSosialKabupaten.length > 0 && <TblSosEkonomi data={this.state.indekSosialKabupaten} />}</Col>
                            </Row>
                        </div>

                        <a className="float-button" onClick={this.doPrint}>
                            {/* <i className="fa fa-print my-float-button"></i> */}
                            <PrintIcon className="my-float-button" />
                        </a>
                    </div>
                )}
            </div>
        );
    }

    doPrint = (e) => {
        e.preventDefault();
        document.title = "Report_Asesmen_Nasional__" + this.props.match.params.kodeJenjangSekolah + "__" + this.state.namaDisdikSelected;
        window.print();
    };
    loadAlert = () => {
        const { alertShow } = this.state;
        if (alertShow) {
            return (
                <Alert variant="danger" onClose={() => this.setState({ alertShow: false })} dismissible>
                    <strong>{this.state.resMessage}</strong>
                </Alert>
            );
        }
    };

    pieChart(values) {
        let title = values.namaMataPelajaran + " (dalam %)";
        let data = [];
        let label = [];
        values.kategories.map((item) => {
            data.push(item.persen);
            label.push(item.kategori);
        });

        return (
            <>
                <Pie
                    data={{
                        labels: label,
                        datasets: [
                            {
                                data: data,
                                backgroundColor: ["rgb(255, 99, 132)", "rgb(75, 192, 192)", "rgb(255, 205, 86)", "rgb(54, 162, 235)"],
                            },
                        ],
                    }}
                    width={460}
                    height={320}
                    options={{
                        legend: { position: "bottom" },
                        title: {
                            display: true,
                            text: title,
                        },
                        responsive: false,
                        maintainAspectRatio: true,
                    }}
                />
            </>
        );
    }
}

export default ReportAsmDinas;
